module.exports = __webpack_public_path__ + "img/box.17748f71.png";